export const KNOWLEDGE_CARDS_EXTENSION_KEY = 'knowledge-cards';
